import React from 'react';
import cn from 'classnames';
import { Typography, Spinner } from 'seagull';
import styles from "./GraphWidgetLayout.module.scss";
/**
 * Renders the basic layout for a graph widget - a variable amount of cards in the 1st row,
 * and a full-width card in the 2nd row.
 */
export default function GraphWidgetLayout(props) {
  const {
    children,
    title,
    subtitle,
    loading,
    bottomHeight = 'm',
    testid
  } = props;
  const childrenLength = React.Children.count(children);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testid
  }, title && /*#__PURE__*/React.createElement(Typography, {
    weight: "normal",
    skin: "secondary",
    variant: "h6",
    className: styles.title
  }, title, loading && /*#__PURE__*/React.createElement(Spinner, {
    "data-testid": "graph-widget-loading",
    size: 24
  })), subtitle && /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.grid, styles["".concat(bottomHeight, "BottomHeight")]),
    style: {
      '--num-cols': childrenLength - 1
    }
  }, React.Children.map(children, (child, idx) => {
    const isLastChild = idx === childrenLength - 1;
    if (isLastChild && /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        className: cn(child.props.className, styles.fullWidthCell)
      });
    }
    return child;
  })));
}